export default __webpack_public_path__ + "static/media/feedback.da1f87fd.svg";